/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// v6 version flags; positive value = on, -1 = off (platform-scoped in settings API).
export const SSO_SOCIAL_FEATURE_FLAGS = {
  GOOGLE: 'enable_google_signup_v6',
  APPLE: 'enable_apple_signup_v6',
  FACEBOOK: 'enable_facebook_signup_v6',
  WECHAT: 'enable_wechat_signup_v6',
  LOGIN_2FA: 'enable_sso_login_2fa_v6',
} as const;

// Remaining signup JSON flags (parental_guidance, provider_order).
export const SSO_SIGNUP_FEATURE_FLAGS = 'sso_signup_feature_flags' as const;

export type SsoSignupProviderId = 'facebook' | 'google' | 'apple' | 'wechat';

export const SSO_SIGNUP_PROVIDER_ORDER_DEFAULT: SsoSignupProviderId[] = [
  'facebook',
  'google',
  'apple',
  'wechat',
];

export type SsoSignupFeatureFlags = {
  parental_guidance: boolean;
  facebook_login: boolean;
  google_login: boolean;
  apple_login: boolean;
  wechat_login: boolean;
  enable_sso_login_2fa_v6: boolean;
  provider_order: SsoSignupProviderId[];
};

export const SSO_SIGNUP_FEATURE_FLAGS_DEFAULT: SsoSignupFeatureFlags = {
  parental_guidance: false,
  facebook_login: false,
  google_login: true,
  apple_login: true,
  wechat_login: false,
  enable_sso_login_2fa_v6: true,
  provider_order: [...SSO_SIGNUP_PROVIDER_ORDER_DEFAULT],
};
